export default "__VITE_ASSET__CsuhdOyw__"